export const iconFontAwesomeSocialCircleUser = (
	<i className="fa-solid fa-circle-user"></i>
);
